import { AWARDS as type } from '@/store/types';
import Awards from '@/services/Api/Awards';
import S3Uploader from '@/services/S3Uploader';

const state = {
  data: [],
  current: null,
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
  [type.SET_CURRENT](state, data) {
    state.current = data;
  },
};

const actions = {
  setCurrentAward({ commit }, payload) {
    commit(type.SET_CURRENT, payload);
  },
  requestUpload(context, payload) {
    return Awards.uploadFile(payload.awardId, payload.uploadPayload);
  },
  uploadFile(context, payload) {
    return S3Uploader.put(payload.url, payload.file);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
